import { LiveLikeFollowUp } from "@livelike/engagementsdk";
import "./sbs-image-prediction-followup-option";
import "./sbs-prediction-followup-widget.css";
const html = (window as any).html;

class CustomImagePredictionFollowup extends LiveLikeFollowUp {
  claimRewards = () => {};
  render() {
    const isUserCorrect =
      this.isUserRight ?? this.interaction?.is_correct ?? false;
    return html`
      <template kind="image-prediction-follow-up" id="custom-prediction">
        <livelike-widget-root class="custom-widget">
          <livelike-widget-header class="widget-header" slot="header">
            <livelike-title class="custom-title"></livelike-title>
          </livelike-widget-header>
          <livelike-widget-body>
            <livelike-select
              class="${this.widgetPayload.options.length === 3
                ? "sbs-3x1"
                : ""}"
            >
              <template>
                <sbs-image-prediction-followup-option></sbs-image-prediction-followup-option>
              </template>
            </livelike-select>
            <livelike-footer>
              <div class="sbs-followup-result">
                ${this.interaction || this.isUserInteracted
                  ? isUserCorrect
                    ? "correct!"
                    : "incorrect!"
                  : "not answered"}
              </div>
            </livelike-footer>
          </livelike-widget-body>
        </livelike-widget-root>
      </template>
    `;
  }
}

customElements.define(
  "sbs-prediction-followup-widget",
  CustomImagePredictionFollowup as any
);
